module.exports = __webpack_public_path__ + "static/media/PreProcessor.9b10cb38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lms/PreProcessor.jpg
// module id = 415
// module chunks = 0